/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface LowEnrollmentClassRow
 */
export interface LowEnrollmentClassRow {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof LowEnrollmentClassRow
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof LowEnrollmentClassRow
     */
    className: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof LowEnrollmentClassRow
     */
    enrollmentCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof LowEnrollmentClassRow
     */
    capacity: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof LowEnrollmentClassRow
     */
    utilizationPercent: number;
}

/**
 * Check if a given object implements the LowEnrollmentClassRow interface.
 */
export function instanceOfLowEnrollmentClassRow(value: object): value is LowEnrollmentClassRow {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('enrollmentCount' in value) || value['enrollmentCount'] === undefined) return false;
    if (!('capacity' in value) || value['capacity'] === undefined) return false;
    if (!('utilizationPercent' in value) || value['utilizationPercent'] === undefined) return false;
    return true;
}

export function LowEnrollmentClassRowFromJSON(json: any): LowEnrollmentClassRow {
    return LowEnrollmentClassRowFromJSONTyped(json, false);
}

export function LowEnrollmentClassRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): LowEnrollmentClassRow {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'className': json['className'],
        'enrollmentCount': ApiUserTasksGetPageParameterFromJSON(json['enrollmentCount']),
        'capacity': ApiUserTasksGetPageParameterFromJSON(json['capacity']),
        'utilizationPercent': json['utilizationPercent'],
    };
}

export function LowEnrollmentClassRowToJSON(json: any): LowEnrollmentClassRow {
    return LowEnrollmentClassRowToJSONTyped(json, false);
}

export function LowEnrollmentClassRowToJSONTyped(value?: LowEnrollmentClassRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'className': value['className'],
        'enrollmentCount': ApiUserTasksGetPageParameterToJSON(value['enrollmentCount']),
        'capacity': ApiUserTasksGetPageParameterToJSON(value['capacity']),
        'utilizationPercent': value['utilizationPercent'],
    };
}

